import { handleResponse, Headers } from '../_helpers';

//Retrieve a single Article's Data
export function getArticleData(articleID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };
  return fetch(`${process.env.API_URL}/api/v1/articles/${articleID}`, request)
    .then(handleResponse)
    .then((result) => result);
}

export function searchArticles(query, worldID, options) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify({ worldID }),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/articles/search?term=${query}`,
    request
  )
    .then(handleResponse)
    .then((results) => results);
}
